import React from 'react';
import PropTypes from 'prop-types';

import Context from './Context';

import PageTitleNew from '../../ui/PageTitleNew';
import Table from './Table';

export default function Index({ affiliateId, showTitle }) {
  return (
    <Context affiliateId={affiliateId}>
      {showTitle ? (
        <div className="wrapper_assestment invite_wrapper">
          <PageTitleNew title="Affiliate Payments" />

          <div className="ibox-content mt20">
            <Table />
          </div>
        </div>
      ) : <Table />}
    </Context>
  );
}

Index.propTypes = {
  affiliateId: PropTypes.number,
  showTitle: PropTypes.bool,
};

Index.defaultProps = {
  affiliateId: null,
  showTitle: true,
};
